export default __webpack_public_path__ + "static/media/jaAnunciei.af44f246.svg";